// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3KRsX","header":"MessagesList_header__k8dLC","chat":"MessagesList_chat__3bWPC"};